{
 "deck": "major_arcana",
 "version": "draft-1",
 "tone_rules": [
  "사주·타로 용어는 풀어서 쉬운 말로",
  "단정하지 않고 경향과 조언으로",
  "한 문단 3문장 이내, 친근한 존댓말",
  "겁주는 표현 대신 조심하면 좋은 부분으로",
  "건강·투자 종목·법률 판단은 다루지 않음",
  "기혼자에게 새 인연을 암시하지 않음",
  "거꾸로 나온 카드는 막힘·지연·내면 점검으로 부드럽게",
  "날짜는 재료에 날짜가 있을 때만, 시간 순서대로, 한 문단에 날짜 구간은 두 개까지, 시작일~끝일 한 가지 꼴로만 쓴다",
  "사주 용어를 억지로 바꾼 말(틀을 깨는 기운, 통제하려는 기운이 센 사람 등) 대신 행동과 장면으로 쓴다"
 ],
 "age_focus": {
  "teen_20s": "연애, 진로, 첫 직장, 친구",
  "30s": "결혼·연애, 이직, 돈 모으기",
  "40s_50s": "직장 내 위치, 사업, 자녀, 부부",
  "60plus": "은퇴 후 삶, 가족, 새 취미"
 },
 "topics": {
  "love_single": "연애 (싱글)",
  "love_dating": "연애 (연애 중)",
  "love_married": "연애 (기혼)",
  "work": "일·직장",
  "business": "사업·돈",
  "study": "공부·진로",
  "family": "가족",
  "self": "나 자신"
 },
 "cards": [
  {
   "id": 0,
   "minhwa": "보따리를 멘 젊은 선비가 까치 한 마리와 함께 벼랑 끝 소나무 길을 웃으며 걷는 모습"
  },
  {
   "id": 1,
   "minhwa": "책상 위에 붓, 벼루, 엽전, 청자 잔을 늘어놓고 한 손을 하늘로 든 도사"
  },
  {
   "id": 2,
   "minhwa": "달빛 아래 연못가에서 두루마리를 품에 안고 조용히 앉은 여인, 뒤로 드리운 발"
  },
  {
   "id": 3,
   "minhwa": "모란이 가득 핀 정원에서 석류와 곡식 바구니 곁에 앉아 미소 짓는 왕비"
  },
  {
   "id": 4,
   "minhwa": "일월오봉도 병풍 앞 옥좌에 곧게 앉아 홀을 든 임금"
  },
  {
   "id": 5,
   "minhwa": "서원 마루에서 제자 둘에게 경전을 펼쳐 가르치는 백발 스승"
  },
  {
   "id": 6,
   "minhwa": "원앙 한 쌍이 노니는 연못 위 다리에서 마주 선 두 사람, 하늘에 복숭아꽃"
  },
  {
   "id": 7,
   "minhwa": "청룡과 백호가 끄는 수레 위에서 깃발을 들고 앞으로 나아가는 장수"
  },
  {
   "id": 8,
   "minhwa": "호랑이 머리를 부드럽게 쓰다듬는 여인, 호랑이는 순하게 웃고 있는 까치호랑이 풍"
  },
  {
   "id": 9,
   "minhwa": "눈 덮인 산길에서 청사초롱을 들고 홀로 걷는 노스님"
  },
  {
   "id": 10,
   "minhwa": "십이지 동물이 둘레를 따라 도는 커다란 물레방아, 가운데 태극 문양"
  },
  {
   "id": 11,
   "minhwa": "한 손에 저울, 한 손에 붓을 든 사또가 대청마루에 바르게 앉은 모습"
  },
  {
   "id": 12,
   "minhwa": "버드나무 가지에 거꾸로 매달려 편안히 웃는 광대, 발아래 연꽃 연못"
  },
  {
   "id": 13,
   "minhwa": "낙엽 진 나뭇가지에서 새싹이 돋고, 나비가 된 고치가 날아가는 가을 끝 풍경"
  },
  {
   "id": 14,
   "minhwa": "두 개의 청자 주전자로 물을 옮겨 붓는 선녀, 발 하나는 물가 하나는 땅에"
  },
  {
   "id": 15,
   "minhwa": "도깨비가 금방망이를 들고 엽전 꾸러미로 두 사람을 느슨하게 묶은 익살스러운 모습"
  },
  {
   "id": 16,
   "minhwa": "번개 치는 밤, 기왓장이 날리는 누각과 그 너머로 밝아오는 새벽 산"
  },
  {
   "id": 17,
   "minhwa": "북두칠성 아래 우물가에서 물항아리 둘을 붓는 소녀, 곁에 학 한 마리"
  },
  {
   "id": 18,
   "minhwa": "보름달 아래 안개 낀 갈림길, 한쪽엔 여우 한쪽엔 삽살개가 달을 올려다보는 모습"
  },
  {
   "id": 19,
   "minhwa": "해바라기 가득한 들판에서 백마를 탄 아이가 해를 향해 손을 흔드는 밝은 모습"
  },
  {
   "id": 20,
   "minhwa": "새벽 산마루에서 나팔 대신 태평소를 부는 신선, 아래에서 깨어나 올려다보는 사람들"
  },
  {
   "id": 21,
   "minhwa": "오방색 띠를 두른 원 안에서 춤추는 무희, 네 귀퉁이에 청룡 백호 주작 현무"
  },
  {
   "id": 22,
   "minhwa": "마른 가지 하나에서 새순이 돋고, 그 끝을 구름 사이로 뻗은 손이 쥐고 있는 모습"
  },
  {
   "id": 23,
   "minhwa": "담 너머 먼 들판을 바라보며 지도를 펼쳐 든 사내, 곁에 심어 둔 나무 지팡이 둘"
  },
  {
   "id": 24,
   "minhwa": "언덕 위에서 떠나는 배를 지켜보는 사람, 등 뒤로 세워 둔 지팡이 셋"
  },
  {
   "id": 25,
   "minhwa": "꽃을 엮어 세운 네 기둥 아래에서 두 사람이 손을 들어 맞이하는 잔치 마당"
  },
  {
   "id": 26,
   "minhwa": "마당에서 각자 막대를 든 다섯 젊은이가 뒤엉켜 겨루는 모습"
  },
  {
   "id": 27,
   "minhwa": "머리에 띠를 두르고 말 위에 앉아 돌아오는 사람, 뒤따르는 사람들이 막대를 들었다"
  },
  {
   "id": 28,
   "minhwa": "언덕 위에 서서 아래에서 올라오는 여섯 막대를 혼자 막아 내는 사람"
  },
  {
   "id": 29,
   "minhwa": "하늘을 가로질러 날아가는 여덟 개의 막대, 아래로 펼쳐진 들과 강"
  },
  {
   "id": 30,
   "minhwa": "붕대를 감은 채 막대에 기대어 담장 너머를 살피는 파수꾼"
  },
  {
   "id": 31,
   "minhwa": "열 개의 막대를 한 아름 안고 등을 굽힌 채 마을로 들어가는 사람"
  },
  {
   "id": 32,
   "minhwa": "지팡이 끝을 올려다보며 무언가를 말하려는 젊은이, 뒤로 펼쳐진 황토 벌판"
  },
  {
   "id": 33,
   "minhwa": "붉은 갑옷을 입고 앞발을 든 말 위에서 지팡이를 세워 든 기수"
  },
  {
   "id": 34,
   "minhwa": "해바라기를 곁에 두고 의자에 앉아 지팡이를 짚은 여인, 발치에 검은 고양이"
  },
  {
   "id": 35,
   "minhwa": "사자 무늬 옷을 입고 지팡이를 짚은 채 비스듬히 앉은 임금, 곁에 도마뱀 한 마리"
  },
  {
   "id": 36,
   "minhwa": "연잎 위에 놓인 백자 잔 하나, 맑은 물이 찰랑이고 그 위로 연꽃 한 송이가 피어 있는 그림"
  },
  {
   "id": 37,
   "minhwa": "냇물을 사이에 두고 마주 선 두 사람이 서로에게 잔을 건네는 모습"
  },
  {
   "id": 38,
   "minhwa": "달빛 아래 세 여인이 손을 맞잡고 둥글게 돌며 웃는 장면"
  },
  {
   "id": 39,
   "minhwa": "나무 그늘에 앉아 턱을 괴고 눈앞의 잔을 본 척 만 척하는 사람"
  },
  {
   "id": 40,
   "minhwa": "엎어진 잔 셋을 내려다보는 뒷모습, 뒤에는 아직 선 잔 둘이 남아 있다"
  },
  {
   "id": 41,
   "minhwa": "옛 담장 아래에서 아이가 꽃을 담은 잔을 어른에게 건네는 그림"
  },
  {
   "id": 42,
   "minhwa": "구름 사이로 떠오른 일곱 개의 잔, 저마다 다른 것이 담겨 있다"
  },
  {
   "id": 43,
   "minhwa": "달 뜬 밤 물가를 따라 등을 보이며 걸어가는 사람과 남겨진 잔들"
  },
  {
   "id": 44,
   "minhwa": "마루에 편히 앉아 아홉 잔을 등 뒤에 둔 채 흐뭇하게 웃는 사람"
  },
  {
   "id": 45,
   "minhwa": "무지개 아래 마당에서 온 가족이 손을 들어 웃는 장면"
  },
  {
   "id": 46,
   "minhwa": "잔 안의 물고기를 신기한 듯 들여다보는 젊은이"
  },
  {
   "id": 47,
   "minhwa": "잔을 조심스레 받쳐 들고 말을 몰아 강을 건너는 사람"
  },
  {
   "id": 48,
   "minhwa": "물가에 앉아 잔 속을 가만히 들여다보는 여인, 옷자락이 물결과 이어져 있다"
  },
  {
   "id": 49,
   "minhwa": "거친 물결 위 자리에 앉아 흔들림 없이 잔을 든 사람"
  },
  {
   "id": 50,
   "minhwa": "구름을 가르고 솟은 한 자루 검, 그 끝에 화관이 걸려 있는 그림"
  },
  {
   "id": 51,
   "minhwa": "눈을 천으로 가린 채 두 검을 가슴 앞에 엇갈려 든 사람, 뒤로 잔잔한 물"
  },
  {
   "id": 52,
   "minhwa": "붉은 구름 아래 세 자루 검이 꽂힌 심장, 비가 가늘게 내리는 장면"
  },
  {
   "id": 53,
   "minhwa": "마루에 누워 두 손을 모은 사람, 벽에 검 셋이 나란히 걸려 있다"
  },
  {
   "id": 54,
   "minhwa": "검을 그러모아 든 사람과 등을 보이며 물러가는 두 사람"
  },
  {
   "id": 55,
   "minhwa": "배에 검 여섯을 세우고 잔잔한 물을 건너는 사공과 두 사람"
  },
  {
   "id": 56,
   "minhwa": "밤중에 검 다섯을 안고 발끝으로 빠져나오는 사람, 뒤에는 천막"
  },
  {
   "id": 57,
   "minhwa": "천에 묶인 채 검 여덟에 둘러싸여 서 있는 사람, 발밑은 열려 있다"
  },
  {
   "id": 58,
   "minhwa": "한밤중 자리에 앉아 두 손으로 얼굴을 가린 사람, 벽에 검 아홉"
  },
  {
   "id": 59,
   "minhwa": "엎드린 사람 등에 검 열, 저 멀리 하늘이 노랗게 밝아 온다"
  },
  {
   "id": 60,
   "minhwa": "언덕 위에서 검을 세워 들고 바람 부는 쪽을 살피는 젊은이"
  },
  {
   "id": 61,
   "minhwa": "머리를 숙이고 바람을 가르며 말을 몰아 달려가는 사람"
  },
  {
   "id": 62,
   "minhwa": "구름 위 자리에 앉아 한 손을 들고 검을 곧게 세운 여인"
  },
  {
   "id": 63,
   "minhwa": "정면을 보고 앉아 검을 바로 세워 든 사람, 뒤로 곧은 나무 두 그루"
  },
  {
   "id": 64,
   "minhwa": "구름 사이로 내민 손이 엽전 한 닢을 받쳐 든 그림, 아래로 울타리 두른 밭"
  },
  {
   "id": 65,
   "minhwa": "엽전 두 닢을 양손으로 번갈아 굴리는 사람, 뒤로 물결치는 강"
  },
  {
   "id": 66,
   "minhwa": "절집 기둥 앞에서 대패를 든 목수와 그를 지켜보는 두 사람"
  },
  {
   "id": 67,
   "minhwa": "엽전을 품에 꼭 안고 머리에도 이고 앉은 사람, 발밑에도 두 닢"
  },
  {
   "id": 68,
   "minhwa": "눈 내리는 밤 담장 밖을 지나는 두 사람, 담 안에는 불 밝힌 창"
  },
  {
   "id": 69,
   "minhwa": "저울을 한 손에 들고 다른 손으로 엽전을 나눠 주는 사람"
  },
  {
   "id": 70,
   "minhwa": "괭이에 몸을 기대고 열린 열매를 바라보며 서 있는 농부"
  },
  {
   "id": 71,
   "minhwa": "작은 상 앞에 앉아 엽전을 하나씩 새기고 있는 장인"
  },
  {
   "id": 72,
   "minhwa": "잘 가꾼 뜰에 홀로 서서 팔에 새매를 앉힌 여인"
  },
  {
   "id": 73,
   "minhwa": "큰 집 마당에 모인 세 대의 식구와 그 곁에 엎드린 개 두 마리"
  },
  {
   "id": 74,
   "minhwa": "엽전 한 닢을 두 손으로 들어 올려 골똘히 들여다보는 젊은이"
  },
  {
   "id": 75,
   "minhwa": "검은 말에 올라 엽전을 든 채 밭 앞에 멈춰 선 사람"
  },
  {
   "id": 76,
   "minhwa": "꽃이 만발한 뜰에 앉아 무릎 위 엽전을 내려다보는 여인"
  },
  {
   "id": 77,
   "minhwa": "포도 덩굴 무늬 옷을 입고 엽전을 든 채 앉은 임금, 뒤로 성과 밭"
  }
 ]
}
